<template>
  <q-drawer
    v-model="getIsOpen"
    side="left"
    overlay
    elevated
    class="bg-grey-1 text-black"
  >
    <q-scroll-area class="fit">
      <q-list>
        <div v-for="(menuItem, index) in menuList" :key="index">
          <q-item
            v-show="
              menuItem.access === 'All' || roles.includes(menuItem.access)
            "
            clickable
            :active="handlerActive(menuItem.link)"
            v-ripple
            :to="menuItem.link"
            @click="handlerClick()"
          >
            <q-item-section avatar>
              <font-awesome-icon :icon="menuItem.icon" size="xl" />
            </q-item-section>

            <q-item-section>
              {{ menuItem.label }}
            </q-item-section>
          </q-item>
          <q-separator :key="'sep' + index" v-if="menuItem.separator" />
        </div>
      </q-list>
    </q-scroll-area>
  </q-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { menuList } from "./constants";

export default {
  name: "SideBar",

  data() {
    return {
      menuList,
      roles: [],
    };
  },

  computed: {
    ...mapGetters({ getIsOpen: "sidebar/getIsOpen" }),
    ...mapGetters({
      getUser: "auth/getUser",
    }),
  },

  created() {
    if (this.getUser) {
      this.roles = this.getUser.idTokenClaims.roles;
    }
  },

  methods: {
    ...mapActions({
      setSideMenuOpen: "sidebar/setSideMenuOpen",
    }),

    handlerClick() {
      this.setSideMenuOpen(false);
    },

    // Set item as active to change their Css
    handlerActive(link) {
      return link === this.$route.path;
    },
  },
};
</script>

<style lang="scss">
.q-focus-helper {
  width: 0 !important;
  height: 0 !important;
}

.q-item:hover {
  transition: all 0.6s ease;
  background-color: $primary;
  color: $white;
  padding-left: 21px;
}

.q-item.q-router-link--active:hover,
.q-item--active:hover {
  transition: all 0.6s ease;
  background-color: $secondary;
  font-weight: bold;
  padding-left: 21px;
}
</style>
